import PropTypes from "prop-types";
import styles from "components/narrative/Prompt.module.scss";

export default function Prompt({ photo, title, action }) {
  return (
    <div className={styles.component}>
      {photo}
      <div className={styles.overlay}>
        <div className={styles.title}>{title}</div>
        <div className={styles.action}>{action}</div>
      </div>
    </div>
  );
}

Prompt.propTypes = {
  photo: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  action: PropTypes.node.isRequired,
};
